import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class QuoteApprovedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-danger"}>
                        <Icon value={"times-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="quote.analytics.events.declined.text"
                            defaultMessage="Proposal {identifier} has been lost"
                            values={{
                                identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                            }}
                        />
                    </p>
                    {
                        this.state.quote && this.state.quote.attributes.declinedReasonNotes &&
                        <p className={'mb-0 text-secondary blockquote-footer mt-2'}>
                            {this.state.quote.attributes.declinedReasonNotes}
                        </p>
                    }
                </div>
            </div>
        </div>
    }

}

export default QuoteApprovedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-declined.component.jsx